var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevicesFold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66602 19.0129C9.17102 19.0129 8.74727 18.8366 8.39477 18.4841C8.04227 18.1316 7.86602 17.7079 7.86602 17.2129V3.96036C7.86602 3.60036 7.96352 3.27411 8.15852 2.98161C8.35352 2.68911 8.61602 2.46786 8.94602 2.31786L11.646 1.14786C12.246 0.89286 12.816 0.94161 13.356 1.29411C13.896 1.64661 14.166 2.15286 14.166 2.81286H16.866C17.361 2.81286 17.7848 2.98911 18.1373 3.34161C18.4898 3.69411 18.666 4.11786 18.666 4.61286V17.2129C18.666 17.7079 18.4898 18.1316 18.1373 18.4841C17.7848 18.8366 17.361 19.0129 16.866 19.0129H9.66602ZM9.66602 16.2904L12.366 15.1204V2.81286L9.66602 3.98286V16.2904ZM12.0735 17.2129H16.866V4.61286H14.166V15.1204C14.166 15.4804 14.0685 15.8141 13.8735 16.1216C13.6785 16.4291 13.416 16.6504 13.086 16.7854L12.0735 17.2129ZM0.666016 4.61286V2.81286H2.46602V4.61286H0.666016ZM0.666016 19.0129V17.2129H2.46602V19.0129H0.666016ZM0.666016 15.4129V13.6129H2.46602V15.4129H0.666016ZM0.666016 11.8129V10.0129H2.46602V11.8129H0.666016ZM0.666016 8.21286V6.41286H2.46602V8.21286H0.666016ZM4.26602 4.61286V2.81286H6.06602V4.61286H4.26602ZM4.26602 19.0129V17.2129H6.06602V19.0129H4.26602Z",
    fill: "#1D1D39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevicesFold);
export default __webpack_public_path__ + "static/media/devices_fold.50db0caefeb5e3f7b9086e0a74989e1a.svg";
export { ForwardRef as ReactComponent };